import React from 'react'

const PageNotFound = () => {
  return (
    <div>Sorry! Page not Found.</div>
  )
}

export default PageNotFound
